var _rect, _rect2, _path, _rect3, _rect4, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgOnline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 30,
    rx: 5,
    fill: "#D6E8F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    width: 4,
    height: 30,
    fill: "#B0D2EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23858 2.23858 0 5 0H35V30H5C2.23858 30 0 27.7614 0 25V5Z",
    fill: "#E23E5C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 42,
    width: 70,
    height: 30,
    rx: 5,
    fill: "#D6E8F6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 42,
    width: 4,
    height: 30,
    fill: "#B0D2EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 42H65C67.7614 42 70 44.2386 70 47V67C70 69.7614 67.7614 72 65 72H35V42Z",
    fill: "#3A8761"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6377 59.6379L48.4025 56.4026C47.8167 55.8168 46.8669 55.8168 46.2811 56.4026C45.6954 56.9884 45.6954 57.9381 46.2811 58.5239L50.318 62.5608C50.3791 62.6219 50.4442 62.6766 50.5124 62.725C50.5966 62.8511 50.7015 62.9665 50.8265 63.066C51.4747 63.5819 52.4183 63.4746 52.9342 62.8264L60.288 53.5865C60.8039 52.9383 60.6967 51.9946 60.0485 51.4787C59.4003 50.9629 58.4566 51.0701 57.9407 51.7183L51.6377 59.6379Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9094 9.303C22.3237 8.71722 21.3739 8.71722 20.7881 9.303L17.6066 12.4845L14.4249 9.30285C13.8391 8.71706 12.8894 8.71706 12.3036 9.30285C11.7178 9.88863 11.7178 10.8384 12.3036 11.4242L15.4853 14.6059L12.3028 17.7883C11.7171 18.3741 11.7171 19.3238 12.3028 19.9096C12.8886 20.4954 13.8384 20.4954 14.4242 19.9096L17.6066 16.7272L20.7889 19.9094C21.3747 20.4952 22.3244 20.4952 22.9102 19.9094C23.496 19.3237 23.496 18.3739 22.9102 17.7881L19.7279 14.6059L22.9094 11.4243C23.4952 10.8385 23.4952 9.88879 22.9094 9.303Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgOnline);
export default __webpack_public_path__ + "static/media/imgOnline.7500d3ee5b8e440e0c4b4ae068d2fbce.svg";
export { ForwardRef as ReactComponent };